import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { ApiLoadingState } from '../../middleware/api/apiList'
import { RootState } from '../../stateStore'
import { LoadingState, ValidationError } from '../../types/commonTypes'
import {
  EmployeeOnContractSliceState,
  OnContractDetails,
  onContractApiProps,
} from '../../types/Dashboard/OnContract/onContractTypes'
import employeeOnContractApi from '../../middleware/api/Dashboard/onContractApi'

const getEmployeesOnContract = createAsyncThunk(
  'jobapplicant/getUpcomingOnContractEmployees',
  async (props: onContractApiProps, thunkApi) => {
    try {
      return await employeeOnContractApi.getEmployeesUnderOnContract(props)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const initialProvisionPeriodState: EmployeeOnContractSliceState = {
  listSize: 0,
  isLoading: ApiLoadingState.idle,
  error: null,
  upcomingOnContractList: [],
}

const onContractSlice = createSlice({
  name: 'provisionPeriod',
  initialState: initialProvisionPeriodState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getEmployeesOnContract.pending, (state) => {
        state.isLoading = ApiLoadingState.loading
      })
      .addCase(getEmployeesOnContract.fulfilled, (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.upcomingOnContractList = action.payload.list
        state.listSize = action.payload.size
      })
  },
})

const isLoading = (state: RootState): LoadingState =>
  state.onContractPeriod.isLoading

const employeesUnderOnContract = (state: RootState): OnContractDetails[] =>
  state.onContractPeriod.upcomingOnContractList

const listSize = (state: RootState): number => state.onContractPeriod.listSize

const onContractPeriodThunk = {
  getEmployeesOnContract,
}

const provisionPeriodSelectors = {
  isLoading,
  listSize,
  employeesUnderOnContract,
}

export const OnContractService = {
  ...onContractPeriodThunk,
  actions: onContractSlice.actions,
  selectors: provisionPeriodSelectors,
}

export default onContractSlice.reducer
